var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"anon-bar"},on:{"click":_vm.onTap}},[_c('span',[_vm._v("There is no point to this if you do it alone. Tap here to invite your partner.")])])}
var staticRenderFns = []

export { render, staticRenderFns }